import { CurrentUserInfo } from '@deltek/specification-client/core/Models/currentUserInfo'
import { FirmUserResponse } from '@deltek/specification-client/core/Models/user'
import { useEffect } from 'react'
import {
    GAINSIGHT_APP_AE,
    GAINSIGHT_APP_BPM,
    saveGainsightEvent,
} from './gainsight'

interface GainsightFirmData {
    firm?: {
        name?: string
        subscriptionInfo?: {
            salesforceId?: string
        }
    }
}

interface GainsightAggregatesData {
    firm?: {
        totalProjects?: number
        totalActiveProjects?: number
    }
}

interface UseGainsightIdentifyParams {
    currentUserInfo: CurrentUserInfo | null | undefined
    firmSupportContactData: GainsightFirmData | undefined
    firmGainsightAggregatesData: GainsightAggregatesData | undefined
    currentUserData: FirmUserResponse | undefined
    app: typeof GAINSIGHT_APP_AE | typeof GAINSIGHT_APP_BPM
}

export const useGainsightIdentify = ({
    currentUserInfo,
    firmSupportContactData,
    firmGainsightAggregatesData,
    currentUserData,
    app,
}: UseGainsightIdentifyParams) => {
    useEffect(() => {
        if (
            !currentUserInfo ||
            !firmSupportContactData ||
            !firmGainsightAggregatesData
        )
            return

        const discipline =
            currentUserData?.user?.profileInfo?.professionalDiscipline
        const bpg = currentUserData?.user?.isBestPracticeGroupEnabled

        saveGainsightEvent(
            {
                id: currentUserInfo?.kpUserId ?? '',
                email: currentUserInfo?.email ?? '',
                firstName: currentUserInfo?.firstName ?? '',
                lastName: currentUserInfo?.lastName ?? '',
                role: currentUserInfo?.roles[0] ?? '',
                accountId: currentUserInfo?.account?.accountId ?? '',
                sppt_app: app,
                sppt_firmName: firmSupportContactData?.firm?.name,
                spptUserManagement:
                    app === GAINSIGHT_APP_AE
                        ? currentUserInfo?.roles ?? `${discipline} BPG:${bpg}`
                        : `${currentUserInfo?.roles} ${discipline} BPG:${bpg}`,
            },
            {
                id: currentUserInfo?.account?.accountId ?? '',
                name: firmSupportContactData?.firm?.name,
                sfdcId:
                    firmSupportContactData?.firm?.subscriptionInfo
                        ?.salesforceId ?? '',
                totalProjects:
                    firmGainsightAggregatesData?.firm?.totalProjects?.toString() ??
                    '',
                activeProjects:
                    firmGainsightAggregatesData?.firm?.totalActiveProjects?.toString() ??
                    '',
            }
        )
    }, [
        currentUserInfo,
        firmSupportContactData,
        firmGainsightAggregatesData,
        currentUserData,
        app,
        saveGainsightEvent,
    ])
}
